export const pathPrefix = '/archive';

export const REGION = 'eu-west-3';
export const BUCKET = 'post-ops-data-20190604170747443000000001';
export const BUCKET_PREFIX = 'entry_counts';
